import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { HiOutlineUser, HiOutlineLockClosed } from 'react-icons/hi';
import { IoFastFoodSharp } from 'react-icons/io5';
import "./SignupForm.css"
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginMethod } from '../../hooks/auth';
function SignupForm() {
  const dispatch=useDispatch();
  const navigate=useNavigate();
  const [email, setEmail] = useState('')

    const handlesubmit=(e)=>{
    if(email=="admin@admin.com"){
    navigate("/dashboard/Dashboard");
        dispatch(loginMethod({
userArray:{
  token:"123456789",
  user:{
    role:"Super Admin"
  }
}
        }));
    }else if(email=="student@admin.com"){
    navigate("/dashboard/student-dashbord");
        dispatch(loginMethod({
userArray:{
  token:"123456789",
  user:{
    role:"student"
  }
}
        }));
    }
  }
  return (
    <div className="signup-page-wrapper">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={12}>

            {/* Header Section */}
            <div className="text-center mb-4">
              <div className="brand-icon-box">
                <IoFastFoodSharp size={28} color="#005a32" />
              </div>
              <h2 className="fw-bold mt-3" style={{ color: '#1a1a1a' }}>ادارة مطاعم الاكاديمية </h2>
              <p className="text-muted">إدارة دقيقة للمطبخ العصري.</p>
            </div>

            {/* signup Card */}
            <Card className="border-0  p-4" style={{ borderRadius: '16px' }}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-uppercase text-muted">
                    البريد الإلكتروني أو اسم المستخدم
                  </Form.Label>
                  <div className="input-group custom-input-group">

                    <Form.Control type="text" placeholder="e.g. chef.remy@academy.edu" />
                    <span className="input-group-text">
                      <HiOutlineUser size={18} />
                    </span>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <div className="d-flex justify-content-between">
                    <Form.Label className="small fw-bold text-uppercase text-muted">
                      كلمة المرور
                    </Form.Label>
                  </div>
                  <div className="input-group custom-input-group">

                    <Form.Control type="password" placeholder="••••••••" />
                    <span className="input-group-text">
                      <HiOutlineLockClosed size={18} />
                    </span>
                  </div>
                </Form.Group>



                <Button className="w-100 btn-secure-signup" onClick={handlesubmit}>
                  تسجيل   <span className="ms-2">→</span>
                </Button>

                <div className="text-center my-4">
                  <hr className="text-muted opacity-25" />
                  <p className="small">
                     <Link to="/login" className="academy-link">تسجيل  الدخول</Link>
                  </p>
                </div>


              </Form>
            </Card>

            {/* Footer */}

          </Col>
        </Row>
      </Container>
    </div>)
}

export default SignupForm